export interface RRIStackedBarData {
  label: string;
  percentage: number;
  count: number;
  color: string;
}
